import React from 'react'

const ConfirmationPopup = (props) => {
  const { SetStatus } = props;
  return (
    <>
      <div className="avnet-modal modal-600">
        <div className="avnet-modal-inner">
          <button type="button" className="close py-3" data-dismiss="modal"
            onClick={() => {
              SetStatus(false)
            }}>×</button>
          <div className="modal-header">
            <h4 className="modal-title text-center">Confirmation</h4>
          </div>
          <div className="modal-body mb-5">
            <div className='text-center'>Your message has been sent successfully.</div>
          </div>
          <div className="modal-footer text-center">
            <button type="button" className="bs5 btn btn-primary w145" data-dismiss="modal"
              onClick={() => {
                SetStatus(false)
              }}>Close</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmationPopup